import React, { ReactNode } from 'react';
import { Icon } from 'semantic-ui-react';

import Tooltip from 'components/Tooltip';
import './DataTable.scss';

export type OfferDataTableRow = {
  label?: ReactNode;
  value: ReactNode;
  error?: string;
};

type Props = { headers?: ReactNode[]; rows: OfferDataTableRow[] };

export function OfferDataTable(props: Props) {
  const getClassName = (row: OfferDataTableRow) => {
    if (row.error) {
      return 'error';
    }
    if (!row.label) {
      return 'combined-row';
    }
    return '';
  };

  const renderRow = (row: OfferDataTableRow, i: number) => (
    <tr className={getClassName(row)} key={i}>
      {row.label && (
        <td key={`label-${i}`}>
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            {row.error && (
              <Tooltip width={200} text={row.error}>
                <Icon name="warning sign" />
              </Tooltip>
            )}
            {row.label}
          </div>
        </td>
      )}
      {
        <td key={`value-${i}`} colSpan={row.label ? 1 : 2}>
          {row.value}
        </td>
      }
    </tr>
  );

  const { headers, rows } = props;
  return (
    <div className="data-table-container">
      <table className="data-table">
        {headers && (
          <thead>
            <tr>
              {headers.map((header, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <th key={`header-${i}`}>{header}</th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>{rows.map(renderRow)}</tbody>
      </table>
    </div>
  );
}
